import { Label } from "@omni/ui/components/Product/Label/label";
import { cn } from "@omni/utils/styles";
import { Fragment } from "react";

import { PromotionPeriodComponent } from "@/components/Product/PromotionPeriod/promotionPeriod.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useProductPageContext } from "../../context/productPage.context";
import { PromotionEnhancer } from "./promotions.helper";

export type PromotionsProps = {
    className?: string;
};

const Promotions = ({ className }: PromotionsProps) => {
    const { t } = useGranite();
    const { product } = useProductPageContext();

    const promotions = PromotionEnhancer(
        product?.price?.promotions || [],
        product.doubleBonusPoints,
        t
    );

    if (promotions.length === 0) {
        return null;
    }

    return (
        <div className={cn("tw:mb-2", className)}>
            {promotions.map((promo, index) => (
                <Fragment key={`promo-${index}`}>
                    <Label
                        type={"label"}
                        position={"left"}
                        className={cn("tw:w-full")}
                    >
                        <Label.Entry className={cn("tw:uppercase tw:p-2")}>
                            {t("productDetail.promoBanner.head")}
                        </Label.Entry>
                        <Label.Entry
                            variant={"secondary"}
                            className={cn("tw:p-2 tw:grow tw:font-normal")}
                        >
                            {promo.marketingText}
                        </Label.Entry>
                    </Label>
                    {promo.validTo && (
                        <PromotionPeriodComponent
                            className={cn("tw:row! tw:gap-2 tw:justify-end")}
                            validFrom={promo.validFrom}
                            validTo={promo.validTo}
                            periodText={promo.periodText}
                        />
                    )}
                </Fragment>
            ))}
        </div>
    );
};

export { Promotions };
